import wx from '@/request/api/wxAuth'
// 获取网址的某个参数值
function getUrlParam(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  const url = window.location.href
  const search = url.split('?')[1]
  if (search) {
    var r = search.substr(0).match(reg)
    if (r !== null) { return unescape(r[2]) }
    return null
  } else { return null }
}
// 判断是否是微信环境
export function isWeixin() {
  var ua = navigator.userAgent.toLowerCase()
  return ua.match(/MicroMessenger/i) == 'micromessenger'
}
// 微信授权
export function wxAuth() {
  return new Promise((resolve, reject) => {
    const code = getUrlParam('code')
    const state = getUrlParam('state')
    if (code) {
      if (state && state.indexOf('STATE') < 0 && state.indexOf('recruitForm') > 0) {
        // 招募页面
        const stateUrlStr = decodeURIComponent(state)
        const searchStrList = stateUrlStr.split('?')[1]?.split('&')
        // ['key=value']
        const obj = {}
        searchStrList.map(v => {
          const vObjArr = v.split('=')
          obj[vObjArr[0]] = vObjArr[1]
        })
        wx.queryAccessTokenWithState(code, obj.researchCode, obj.centerCode).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      } else {
        wx.queryAccessToken(code).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      }
    } else {
      const appid = 'wxad2962200d3af107'
      const redirect_uri = encodeURIComponent(window.location.href)
      let url = ''
      if (redirect_uri.indexOf('recruitForm') > 0) {
        // 招募页面
        url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&state=${redirect_uri}&response_type=code&scope=snsapi_base#wechat_redirect`
      } else {
        url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base#wechat_redirect`
      }
      window.location.href = url
    }
  })
}
